const FlagIcon = ({ countryCode }: { countryCode: string }) => {
	return (
		<img
			src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
			alt={`${countryCode} flag`}
			sizes="(max-width: 767px) 100vw, 10vw"
			loading="lazy"
			decoding="async"
			fetchPriority="low"
			style={{
				width: "16px",
				height: "16px",
				objectFit: "cover",
			}}
		/>
	);
};

export default FlagIcon;
